import type {RewardProfileExpandedCommon} from '../../../api/gamification/types';
import type {Nullable} from '../../utility-types';

export const parseRewardProfile = (
  rewardProfile?: Nullable<RewardProfileExpandedCommon>,
) => {
  const result = {
    currentLevelPoints: 0,
    nextLevelPoints: 0,
    progress: 0,
    progressString: '... / ...',
  };

  result.nextLevelPoints = rewardProfile
    ? (rewardProfile.nextTier || rewardProfile.tier || {upgrade_point_limit: 0})
        .upgrade_point_limit
    : 0;

  result.currentLevelPoints = rewardProfile
    ? (rewardProfile.tier || {upgrade_point_limit: 0}).upgrade_point_limit
    : 0;

  if (rewardProfile && result.nextLevelPoints) {
    const levelsPointsDiff = result.nextLevelPoints - result.currentLevelPoints;

    if (levelsPointsDiff > 0) {
      result.progress =
        (rewardProfile.points - result.currentLevelPoints) / levelsPointsDiff;

      result.progress = parseFloat(result.progress.toPrecision(2));
    } else {
      result.progress = 1;
    }
  }

  if (rewardProfile) {
    result.progressString = `${rewardProfile.points} / ${
      result.nextLevelPoints || '...'
    }`;
  }

  return result;
};
